import React from 'react';
interface Props {
  fillColor?: string;
}
function AnteNatalIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="17"
      viewBox="0 0 12 17"
      fill="none">
      <g clipPath="url(#clip0_851_3580)">
        <path
          d="M7.50027 1.89453C7.50027 1.49671 7.34223 1.11518 7.06093 0.833871C6.77962 0.552566 6.39809 0.394531 6.00027 0.394531C5.60244 0.394531 5.22091 0.552566 4.93961 0.833871C4.6583 1.11518 4.50027 1.49671 4.50027 1.89453C4.50027 2.29236 4.6583 2.67389 4.93961 2.95519C5.22091 3.2365 5.60244 3.39453 6.00027 3.39453C6.39809 3.39453 6.77962 3.2365 7.06093 2.95519C7.34223 2.67389 7.50027 2.29236 7.50027 1.89453ZM3.00027 11.3945C3.00027 11.9477 3.44714 12.3945 4.00027 12.3945V15.6445C4.00027 16.0602 4.33464 16.3945 4.75027 16.3945C5.16589 16.3945 5.50027 16.0602 5.50027 15.6445V12.3945H6.00027H6.50027V15.6445C6.50027 16.0602 6.83464 16.3945 7.25027 16.3945C7.66589 16.3945 8.00027 16.0602 8.00027 15.6445V12.3945H9.50027H10.0003C10.5534 12.3945 11.0003 11.9477 11.0003 11.3945V10.3945C11.0003 8.93203 9.95652 7.71641 8.57214 7.44766L8.38152 6.43203C8.16902 5.30391 7.22214 4.47266 6.09089 4.39766C6.05964 4.39453 6.03152 4.39141 6.00027 4.39141H5.92527L5.50027 4.39453H5.35339C4.33777 4.39453 3.40652 4.95391 2.92839 5.84766L1.08777 9.29141C0.894018 9.65703 1.03152 10.1102 1.39714 10.307C1.76277 10.5039 2.21589 10.3633 2.41277 9.99766L3.00027 8.89766V11.3945ZM5.50027 5.89453H5.92527C6.40652 5.89453 6.81902 6.23828 6.90964 6.71016L7.10027 7.72578C7.21277 8.33203 7.68464 8.80391 8.29089 8.92266C8.98152 9.05703 9.50339 9.66641 9.50339 10.3945V10.8945H6.00339H4.50339V6.89453C4.50339 6.34141 4.95027 5.89453 5.50339 5.89453H5.50027Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3580">
          <rect
            width="12"
            height="16"
            fill="white"
            transform="translate(0 0.394531)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default AnteNatalIcon;
